export default "/packs/images/DSC05525~77870427a5fbf1e676e28e28d3fa6b3d.jpg";